namespace Areas {
    "use strict";

    export function buildCellContent(cellElement: any, getData: () => string, contentTemplate: string) {
        const data = getData();
        const re = /{placeholder}/gi;
        const content = contentTemplate.replace(re, data);
        cellElement.html(content);
    }

    export function gotoSelected(gridName: string, url: string, getAlternateId: (any) => string = null) {
        const dataGrid = $(`#${gridName}`).dxDataGrid("instance");
        const dataId = dataGrid.getSelectedRowKeys()[0];

        if (dataId != null) {
            if (getAlternateId != null) {
                const row = dataGrid.getSelectedRowsData()[0];
                location.href = url + getAlternateId(row);
            }
            else {
                location.href = url + dataId;
            }
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function refreshGrid(id: string) {
        $(`#${id}`).dxDataGrid("instance").refresh();
    }

    export function refreshGridAndGoToKey(id: string, key: number) {
        $(`#${id}`).dxDataGrid("instance").refresh();
        $(`#${id}`).dxDataGrid("instance").selectRows(key[0], true);

    }

    export function refreshData(dataGrid: DevExpress.ui.dxDataGrid) {
        dataGrid.refresh();
        dataGrid.deselectRows(dataGrid.getSelectedRowKeys());
    }

    export function getGrid(gridName: string) : DevExpress.ui.dxDataGrid {
        return $(`#${gridName}`).dxDataGrid("instance");
    }

    export function setRowBackgroundForCurrentRecord(keyName: string) {
        return (e: any) => {
            if (e.rowType !== "data") {
                return;
            }

            const cellIsInRowOfCurrentRecord = e.data[keyName]  === e.component.option(keyName);

            if (cellIsInRowOfCurrentRecord) {
                e.cellElement.css("background-color", "#FFA07A");
            }
        }
    }

}
